import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export const UrgencyBox = () => {
  return <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mx-4 md:mx-6 mt-3 mb-2 flex items-start" data-id="element-120">
      <AlertCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5 mr-2" data-id="element-121" />
      <div data-id="element-122">
        <span className="font-bold text-red-600" data-id="element-123">UPDATE:</span>{' '}
        <span className="font-medium" data-id="element-124">
          NAD+ Cellular Energy Formula Is Nearly Sold Out! Claim Your 45%
          Discount NOW + FREE Priority Shipping For Active Life Readers
        </span>
      </div>
    </div>;
};